module.exports = __webpack_public_path__ + "images/a9218a9d6c243d2cf4e7f4fc3813d406.png";